import {
  CHANGE_PERIOD,
  CHANGE_PROFILE,
  APPLY_ZOOM,
  CANCEL_ZOOM,
  UPDATE_CSV_EXPORT_STATE,
} from "./reports.actions";
import { ReportsState } from "./reports.types";
import {
  DataKeys,
  DrilldownDataKeys,
  ReportsPeriod,
  CsvExportState,
} from "../../helpers/reports.helper.types";
import {
  initialWidgetState,
  widgetReducer,
} from "./reducers/widgets/widgets.reducer";
import {
  LOAD_WIDGET,
  LOAD_WIDGET_FAILURE,
  LOAD_WIDGET_SUCCESS,
} from "./reducers/widgets/widgets.types";
import {
  barChartReducer,
  initialBarChartState,
} from "./reducers/barchart/barchart.reducer";
import {
  LOAD_BARCHART,
  LOAD_BARCHART_FAILURE,
  LOAD_BARCHART_SUCCESS,
} from "./reducers/barchart/barchart.types";
import {
  initialTableState,
  tableReducer,
} from "./reducers/table/table.reducer";
import {
  LOAD_TABLE,
  LOAD_TABLE_FAILURE,
  LOAD_TABLE_SUCCESS,
} from "./reducers/table/table.types";

export const initialState = {
  period: ReportsPeriod.Day,
  profile: "all_profiles",
  widgets: {
    [DataKeys.webfilter]: initialWidgetState,
    [DataKeys.malware]: initialWidgetState,
    [DataKeys.botnet]: initialWidgetState,
  },
  barchart: initialBarChartState,
  table: {
    [DrilldownDataKeys.webfilter]: initialTableState,
    [DrilldownDataKeys.malware]: initialTableState,
    [DrilldownDataKeys.botnet]: initialTableState,
  },
  zoom: {
    visible: false,
  },
  csvExportState: CsvExportState.NOT_STARTED,
};

export const reducer = (
  state: ReportsState = initialState,
  action
): ReportsState => {
  switch (action.type) {
    case LOAD_WIDGET:
    case LOAD_WIDGET_SUCCESS:
    case LOAD_WIDGET_FAILURE: {
      const { id } = action.payload;

      return {
        ...state,
        widgets: {
          ...state.widgets,
          [id]: widgetReducer(state.widgets[id], action),
        },
      };
    }
    case LOAD_BARCHART:
    case LOAD_BARCHART_SUCCESS:
    case LOAD_BARCHART_FAILURE: {
      return {
        ...state,
        barchart: barChartReducer(state.barchart, action),
      };
    }
    case LOAD_TABLE:
    case LOAD_TABLE_SUCCESS:
    case LOAD_TABLE_FAILURE: {
      const { id } = action.payload;

      return {
        ...state,
        table: {
          ...state.table,
          [id]: tableReducer(state.table[id], action),
        },
      };
    }
    case CHANGE_PERIOD:
    case CHANGE_PROFILE: {
      return {
        ...state,
        ...action.payload,
        zoom: initialState.zoom,
      };
    }
    case APPLY_ZOOM: {
      return { ...state, ...action.payload };
    }
    case CANCEL_ZOOM: {
      return {
        ...state,
        zoom: initialState.zoom,
      };
    }
    case UPDATE_CSV_EXPORT_STATE: {
      return {
        ...state,
        csvExportState: action.payload.exportState,
      };
    }
    default:
      return state;
  }
};
